var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('message.partners.head')))]),_c('vs-divider'),_c('vs-tabs',[_c('vs-tab',{attrs:{"label":_vm.$t('message.partners.partners')}},[_c('Internal')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }